// Import boy user profile images
import b1 from "./assets/images/users/boyuser/b1.png";
import b2 from "./assets/images/users/boyuser/b2.png";
import b3 from "./assets/images/users/boyuser/b3.png";
import b4 from "./assets/images/users/boyuser/b4.png";
import b5 from "./assets/images/users/boyuser/b5.png";
import b6 from "./assets/images/users/boyuser/b6.png";
import b7 from "./assets/images/users/boyuser/b7.png";
import b8 from "./assets/images/users/boyuser/b8.png";
import b9 from "./assets/images/users/boyuser/b9.png";
import b10 from "./assets/images/users/boyuser/b10.png";

// Import girl user profile images
import g1 from "./assets/images/users/girluser/g1.png";
import g2 from "./assets/images/users/girluser/g2.png";
import g3 from "./assets/images/users/girluser/g3.png";
import g4 from "./assets/images/users/girluser/g4.png";
import g5 from "./assets/images/users/girluser/g5.png";
import g6 from "./assets/images/users/girluser/g6.png";
import g7 from "./assets/images/users/girluser/g7.png";
import g8 from "./assets/images/users/girluser/g8.png";
import g9 from "./assets/images/users/girluser/g9.png";
import g10 from "./assets/images/users/girluser/g10.png";




// Import boy white profile images
import bw1 from "./assets/images/users/boys/boyswhite/bw1.webp";
import bw2 from "./assets/images/users/boys/boyswhite/bw2.webp";
import bw3 from "./assets/images/users/boys/boyswhite/bw3.webp";
import bw4 from "./assets/images/users/boys/boyswhite/bw4.webp";
import bw5 from "./assets/images/users/boys/boyswhite/bw5.webp";
import bw6 from "./assets/images/users/boys/boyswhite/bw6.webp";
import bw7 from "./assets/images/users/boys/boyswhite/bw7.webp";
import bw8 from "./assets/images/users/boys/boyswhite/bw8.webp";
import bw9 from "./assets/images/users/boys/boyswhite/bw9.webp";
import bw10 from "./assets/images/users/boys/boyswhite/bw10.webp";

// Import girl white profile images
import gw1 from "./assets/images/users/girls/girlswhite/gw1.webp";
import gw2 from "./assets/images/users/girls/girlswhite/gw2.webp";
import gw3 from "./assets/images/users/girls/girlswhite/gw3.webp";
import gw4 from "./assets/images/users/girls/girlswhite/gw4.webp";
import gw5 from "./assets/images/users/girls/girlswhite/gw5.webp";
import gw6 from "./assets/images/users/girls/girlswhite/gw6.webp";
import gw7 from "./assets/images/users/girls/girlswhite/gw7.webp";
import gw8 from "./assets/images/users/girls/girlswhite/gw8.webp";
import gw9 from "./assets/images/users/girls/girlswhite/gw9.webp";
import gw10 from "./assets/images/users/girls/girlswhite/gw10.webp";



// Import boy brown profile images
import bb1 from "./assets/images/users/boys/boysbrown/bb1.webp";
import bb2 from "./assets/images/users/boys/boysbrown/bb2.webp";
import bb3 from "./assets/images/users/boys/boysbrown/bb3.webp";
import bb4 from "./assets/images/users/boys/boysbrown/bb4.webp";
import bb5 from "./assets/images/users/boys/boysbrown/bb5.webp";
import bb6 from "./assets/images/users/boys/boysbrown/bb6.webp";
import bb7 from "./assets/images/users/boys/boysbrown/bb7.webp";
import bb8 from "./assets/images/users/boys/boysbrown/bb8.webp";
import bb9 from "./assets/images/users/boys/boysbrown/bb9.webp";
import bb10 from "./assets/images/users/boys/boysbrown/bb10.webp";

// Import girl brown profile images
import gb1 from "./assets/images/users/girls/girlsbrown/gb1.webp";
import gb2 from "./assets/images/users/girls/girlsbrown/gb2.webp";
import gb3 from "./assets/images/users/girls/girlsbrown/gb3.webp";
import gb4 from "./assets/images/users/girls/girlsbrown/gb4.webp";
import gb5 from "./assets/images/users/girls/girlsbrown/gb5.webp";
import gb6 from "./assets/images/users/girls/girlsbrown/gb6.webp";
import gb7 from "./assets/images/users/girls/girlsbrown/gb7.webp";
import gb8 from "./assets/images/users/girls/girlsbrown/gb8.webp";
import gb9 from "./assets/images/users/girls/girlsbrown/gb9.webp";
import gb10 from "./assets/images/users/girls/girlsbrown/gb10.webp";


// Import boy dark brown profile images
import bd1 from "./assets/images/users/boys/boysdarkbrown/bd1.webp";
import bd2 from "./assets/images/users/boys/boysdarkbrown/bd2.webp";
import bd3 from "./assets/images/users/boys/boysdarkbrown/bd3.webp";
import bd4 from "./assets/images/users/boys/boysdarkbrown/bd4.webp";
import bd5 from "./assets/images/users/boys/boysdarkbrown/bd5.webp";
import bd6 from "./assets/images/users/boys/boysdarkbrown/bd6.webp";
import bd7 from "./assets/images/users/boys/boysdarkbrown/bd7.webp";
import bd8 from "./assets/images/users/boys/boysdarkbrown/bd8.webp";
import bd9 from "./assets/images/users/boys/boysdarkbrown/bd9.webp";
import bd10 from "./assets/images/users/boys/boysdarkbrown/bd10.webp";

// Import girl darek brown profile images
import gd1 from "./assets/images/users/girls/girlsdarkbrown/gd1.webp";
import gd2 from "./assets/images/users/girls/girlsdarkbrown/gd2.webp";
import gd3 from "./assets/images/users/girls/girlsdarkbrown/gd3.webp";
import gd4 from "./assets/images/users/girls/girlsdarkbrown/gd4.webp";
import gd5 from "./assets/images/users/girls/girlsdarkbrown/gd5.webp";
import gd6 from "./assets/images/users/girls/girlsdarkbrown/gd6.webp";
import gd7 from "./assets/images/users/girls/girlsdarkbrown/gd7.webp";
import gd8 from "./assets/images/users/girls/girlsdarkbrown/gd8.webp";
import gd9 from "./assets/images/users/girls/girlsdarkbrown/gd9.webp";
import gd10 from "./assets/images/users/girls/girlsdarkbrown/gd10.webp";

// Export arrays for easier access in other components
export const boys = [b1, b2, b3, b4, b5, b6, b7, b8, b9, b10];
export const girls = [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10];

// student avatar system
export const boyImages = [{image:b1, text:'Astronaut'}, {image:b2, text:'Chemist'}, {image:b3, text:'Doctor'}, {image:b4, text:'Engineer'}, {image:b5, text:'Entrepreneur'},
    {image:b6, text:'Influencer'}, {image:b7, text:'Politician'}, {image:b8, text:'Programmer'}, {image:b9, text:'Scientist'}, {image:b10, text:'Teacher'}];
export const girlImages = [{image:g1, text:'Astronaut'}, {image:g2, text:'Chemist'}, {image:g3, text:'Doctor'}, {image:g4, text:'Engineer'}, {image:g5, text:'Entrepreneur'},
     {image:g6, text:'Influencer'}, {image:g7, text:'Politician'}, {image:g8, text:'Programmer'}, {image:g9, text:'Scientist'}, {image:g10, text:'Teacher'}];
    

// Export arrays for easier access in other components
export const boysWhite = [bw1, bw2, bw3, bw4, bw5, bw6, bw7, bw8, bw9, bw10];
export const girlsWhite = [gw1, gw2, gw3, gw4, gw5, gw6, gw7, gw8, gw9, gw10];     
// student avatar system white skin tone
export const boyImagesWhite = [{image:bw1, text:'Astronaut'}, {image:bw2, text:'Chef'}, {image:bw3, text:'Doctor'}, {image:bw4, text:'Engineer'}, {image:bw5, text:'Entrepreneur'},
  {image:bw6, text:'Influencer'}, {image:bw7, text:'Politician'}, {image:bw8, text:'Programmer'}, {image:bw9, text:'Scientist'}, {image:bw10, text:'Teacher'}];
export const girlImagesWhite = [{image:gw1, text:'Astronaut'}, {image:gw2, text:'Chef'}, {image:gw3, text:'Doctor'}, {image:gw4, text:'Engineer'}, {image:gw5, text:'Entrepreneur'},
   {image:gw6, text:'Influencer'}, {image:gw7, text:'Politician'}, {image:gw8, text:'Programmer'}, {image:gw9, text:'Scientist'}, {image:gw10, text:'Teacher'}];



// Export arrays for easier access in other components
export const boysBrown = [bb1, bb2, bb3, bb4, bb5, bb6, bb7, bb8, bb9, bb10];
export const girlsBrown = [gb1, gb2, gb3, gb4, gb5, gb6, gb7, gb8, gb9, gb10];     

// student avatar system brown skin tone
export const boyImagesBrown = [{image:bb1, text:'Astronaut'}, {image:bb2, text:'Chef'}, {image:bb3, text:'Doctor'}, {image:bb4, text:'Engineer'}, {image:bb5, text:'Entrepreneur'},
  {image:bb6, text:'Influencer'}, {image:bb7, text:'Politician'}, {image:bb8, text:'Programmer'}, {image:bb9, text:'Scientist'}, {image:bb10, text:'Teacher'}];
export const girlImagesBrown = [{image:gb1, text:'Astronaut'}, {image:gb2, text:'Chef'}, {image:gb3, text:'Doctor'}, {image:gb4, text:'Engineer'}, {image:gb5, text:'Entrepreneur'},
   {image:gb6, text:'Influencer'}, {image:gb7, text:'Politician'}, {image:gb8, text:'Programmer'}, {image:gb9, text:'Scientist'}, {image:gb10, text:'Teacher'}];
 
// Export arrays for easier access in other components
export const boysDarkBrown = [bd1, bd2, bd3, bd4, bd5, bd6, bd7, bd8, bd9, bd10];
export const girlsDarkBrown = [gd1, gd2, gd3, gd4, gd5, gd6, gd7, gd8, gd9, gd10];     

// student avatar system Dark brown skin tone
export const boyImagesDarkBrown = [{image:bd1, text:'Astronaut'}, {image:bd2, text:'Chef'}, {image:bd3, text:'Doctor'}, {image:bd4, text:'Engineer'}, {image:bd5, text:'Entrepreneur'},
  {image:bd6, text:'Influencer'}, {image:bd7, text:'Politician'}, {image:bd8, text:'Programmer'}, {image:bd9, text:'Scientist'}, {image:bd10, text:'Teacher'}];
export const girlImagesDarkBrown = [{image:gd1, text:'Astronaut'}, {image:gd2, text:'Chef'}, {image:gd3, text:'Doctor'}, {image:gd4, text:'Engineer'}, {image:gd5, text:'Entrepreneur'},
   {image:gd6, text:'Influencer'}, {image:gd7, text:'Politician'}, {image:gd8, text:'Programmer'}, {image:gd9, text:'Scientist'}, {image:gd10, text:'Teacher'}];
 

// Function to get user profile image
export const getUserProfileImage = (userProfileImg, userGender, userSkinTone) => {

  console.log()
  // Default images
  const defaultBoyImage = userSkinTone ? userSkinTone == 1 ? boysWhite[0] : userSkinTone == 2 ? boysBrown[0] : userSkinTone == 3 ? boysDarkBrown[0] : boysWhite[0] : boysWhite[0] // b1
  const defaultGirlImage = userSkinTone ? userSkinTone == 1 ? girlsWhite[0] : userSkinTone == 2 ? girlsBrown[0] : userSkinTone == 3 ? girlsDarkBrown[0] : girlsWhite[0] : girlsWhite[0] // g1

  // Ensure userProfileImg is a valid number between 1 and 10
  let index = parseInt(userProfileImg, 10);
  if (isNaN(index) || index < 1 || index > 10) {
    index = 1; // Default to index 1 (which is 0 in zero-based array)
  }

  // Convert to zero-based index
  const zeroBasedIndex = index - 1;

  // Determine gender and return corresponding image
  if (userGender?.toLowerCase() === "male") {
    return userSkinTone ? userSkinTone == 1 ? boysWhite[zeroBasedIndex] : userSkinTone == 2 ? boysBrown[zeroBasedIndex] : userSkinTone == 3 ? boysDarkBrown[zeroBasedIndex] : defaultBoyImage : defaultBoyImage;
  } else if (userGender?.toLowerCase() === "female") {
    return userSkinTone ? userSkinTone == 1 ? girlsWhite[zeroBasedIndex] : userSkinTone == 2 ? girlsBrown[zeroBasedIndex] : userSkinTone == 3 ? girlsDarkBrown[zeroBasedIndex] : defaultGirlImage : defaultGirlImage;  
  }else{
    return userSkinTone ? userSkinTone == 1 ? boysWhite[zeroBasedIndex] : userSkinTone == 2 ? boysBrown[zeroBasedIndex] : userSkinTone == 3 ? boysDarkBrown[zeroBasedIndex] : defaultBoyImage : defaultBoyImage;
  }

  // If gender is null, empty, or invalid, return default boy image
  return defaultBoyImage;
};
